export const StatusPagamento = {
    PENDENTE: 0,
    CONCLUIDO: 1,
    CANCELADO: 2,
}